import { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

const getWindowDimensions = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

export default () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    const handleResize = () => setWindowDimensions(getWindowDimensions());

    window.addEventListener('resize', debounce(handleResize, 200));

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
};
